import { render, staticRenderFns } from "./potentialSupplierManageView.vue?vue&type=template&id=7b01a136&scoped=true"
import script from "./potentialSupplierManageView.vue?vue&type=script&lang=js"
export * from "./potentialSupplierManageView.vue?vue&type=script&lang=js"
import style0 from "./potentialSupplierManageView.vue?vue&type=style&index=0&id=7b01a136&lang=scss&scoped=true"
import style1 from "./potentialSupplierManageView.vue?vue&type=style&index=1&id=7b01a136&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b01a136",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b01a136')) {
      api.createRecord('7b01a136', component.options)
    } else {
      api.reload('7b01a136', component.options)
    }
    module.hot.accept("./potentialSupplierManageView.vue?vue&type=template&id=7b01a136&scoped=true", function () {
      api.rerender('7b01a136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/supplierManage/potentialSupplierManageView.vue"
export default component.exports